<template>
  <div>
    <div class="container-dataandpayments">
      <div class="container-dataandpayments__cont-forms">
        <div class="container-dataandpayments__cont-forms__options">
          <div
            class="container-dataandpayments__cont-forms__options__data"
            :class="section == 'data' ? 'active' : ''"
            @click="changeSectionDataAndPayment('data')"
          >
            Ingresa tus datos
          </div>
          <div
            class="container-dataandpayments__cont-forms__options__payments"
            @click="changeSectionDataAndPayment('payment')"
            :class="section == 'payment' ? 'active' : ''"
          >
            Método de pago
          </div>
        </div>
        <div class="container-dataandpayments__cont-forms__package-mobile" v-if="section == 'payment'">
          <PackageSelected />
        </div>
        <div class="container-dataandpayments__cont-forms__forms-load">
          <template v-if="section == 'data'"><Data /></template>
          <template v-else> <Payment /></template>
        </div>
      </div>
      <div class="container-dataandpayments__package"><PackageSelected /></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DataAndPayments',
  components: {
    Data: () => import('@/components/Sections/Buy/Data'),
    Payment: () => import('@/components/Sections/Buy/Payment'),
    PackageSelected: () => import('@/components/Sections/Buy/PackageSelected'),
  },
  data() {
    return {
      section: 'data',
    };
  },
  computed: {},
  watch: {},
  methods: {
    changeSectionDataAndPayment(data) {
      this.section = data;
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.active {
  color: #132839 !important;
}
.container-dataandpayments {
  width: 100%;
  height: 635px;
  margin-top: 10px;
  display: inline-flex;
  justify-content: space-between;
  @media screen and (max-width: 768px) {
    display: inline-block;
  }

  &__cont-forms {
    width: 706px;
    height: 636px;
    border-radius: 8px;
    box-shadow: 0 20px 40px 0 rgba(25, 35, 51, 0.15);
    background: white;
    &__package-mobile {
      display: none;
      @media screen and (max-width: 768px) {
        display: inline-block;
        width: 100%;
        height: auto;
        overflow: hidden;
        background: white;
        border-radius: 8px;
        margin-top: 32px;
        box-shadow: 0 20px 40px 0 rgba(25, 35, 51, 0.15);
      }
    }
    @media screen and (max-width: 1115px) {
      width: 67%;
      // background: green;
    }
    @media screen and (max-width: 1015px) {
      width: 67.5%;
      // background: rgb(1, 168, 160);
    }
    @media screen and (max-width: 915px) {
      width: 63%;
      // background: rgb(10, 240, 228);
    }
    // @media screen and (max-width: 815px) {
    //   width: 63%;
    //   background: rgb(203, 241, 31);
    // }
    @media screen and (max-width: 768px) {
      width: 100%;
      // background: rgb(241, 31, 154);
      box-shadow: none;
      background: transparent;
    }
    &__options {
      width: 640px;
      height: 33px;
      margin-top: 36px;
      display: inline-flex;
      justify-content: space-between;
      @media screen and (max-width: 1115px) {
        width: 94%;
      }
      @media screen and (max-width: 768px) {
        margin-top: 20px;
      }
      &__data {
        width: 640px;
        height: 33px;
        font-family: 'Avenir-Medium';
        font-size: 15px;
        font-weight: 500;
        font-stretch: normal;
        cursor: pointer;
        font-style: normal;
        line-height: 26px;
        letter-spacing: normal;
        text-align: center;
        border-bottom: 1px solid #cbee6b;
        color: rgba(19, 40, 57, 0.5);
      }
      &__payments {
        font-family: 'Avenir-Medium';
        width: 640px;
        height: 33px;
        font-size: 15px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 26px;
        letter-spacing: normal;
        cursor: pointer;
        border-bottom: 1px solid #cbee6b;
        text-align: center;
        color: rgba(19, 40, 57, 0.5);
      }
    }
    &__forms-load {
      width: 100%;
      margin-top: 10px;
      height: 540px;
    }
  }

  &__package {
    width: 352px;
    height: 636px;
    overflow: hidden;
    background: white;
    border-radius: 8px;
    box-shadow: 0 20px 40px 0 rgba(25, 35, 51, 0.15);
    @media screen and (max-width: 1115px) {
      width: 32%;
    }
    @media screen and (max-width: 1015px) {
      width: 31%;
    }
    @media screen and (max-width: 915px) {
      width: 36%;
    }
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
}
</style>
